// ============================================
// Routes Constants
// ============================================

export const ROUTES = {
    DASHBOARD: "/dashboard",
    PROMPT_MANAGER: "/prompt-manager",
    CHAT: "/chat",
    SIGN_IN: "/sign-in",
    DECRYPT: "/decrypt",
};

// ============================================
// Storage Keys Constants
// ============================================

export const STORAGE_KEYS = {
    TOKEN: "token",
    LOGGED_IN_DETAILS: "LoggedInDetails",
    IS_LOGIN: "isLogin",
    INTENDED_ROUTE: "intendedRoute",
};

// ============================================
// Configuration Constants
// ============================================

export const CONFIG = {
    MOBILE_BREAKPOINT: 768,
    SSO_TIMEOUT: 5000,
    TOAST_AUTO_CLOSE: 1500,
    TOAST_POSITION: "top-right",
};

const keyConstants = {
    ROUTES,
    STORAGE_KEYS,
    CONFIG,
};

export default keyConstants;
